export default "__VITE_ASSET__DMqh_2kJ__"